import comboboxClasses from '../combobox/combobox.module.css'
import classes from './select.module.css'

// Input states come from the Input override. Mantine resolves Select's inner
// Combobox styles under the `Select` name, so options reuse the Combobox class.
const Select = {
  classNames: {
    input: classes.input,
    dropdown: classes.dropdown,
    option: comboboxClasses.option,
  },
}

export default Select
